


import React from 'react';
import { 
  Grid, 
  Typography, 
  Paper, 
  Box,
  Tooltip,
  styled 
} from '@mui/material';

const ParameterBox = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1.5),
  borderRadius: theme.shape.borderRadius * 2,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  textAlign: 'center',
  minHeight: 120,
  overflow: 'hidden',
  position: 'relative', // Needed for tooltip positioning
}));

const ParameterValue = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  margin: theme.spacing(0.5, 0),
  fontSize: '1.2rem',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%',
  whiteSpace: 'normal !important',
  wordWrap: 'break-word !important',
  lineHeight: '1 !important',
}));

const ParameterItem = ({ icon, name, value, unit }) => (
  <Grid item xs={6} sm={4} md={3}>
  <Tooltip 
  title={value ?? 'No Data'} 
  placement="bottom"
  arrow
  componentsProps={{
    tooltip: {
      sx: {
        fontSize: '0.875rem',
        padding: '6px 8px',
        bgcolor: 'common.black',
        '& .MuiTooltip-arrow': {
          color: 'common.black',
        }
      }
    }
  }}
>
      <ParameterBox elevation={1}>
        <Box sx={{ 
          width: 36, 
          height: 36, 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'text.secondary',
          mb: 1
        }}>
          {React.cloneElement(icon, { fontSize: 'small' })}
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.9rem' }}>
          {name}
        </Typography>
        <ParameterValue>
          {value }
        </ParameterValue>
        {unit && (
          <Typography variant="caption" color="text.secondary">
            {unit}
          </Typography>
        )}
      </ParameterBox>
    </Tooltip>
  </Grid>
);

export default React.memo(ParameterItem);